import {
    faFacebook,
    faInstagram,
    faLinkedinIn,
    faPinterest,
    faSnapchat,
    faTiktok,
    faTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
    faAward,
    faBoxOpen,
    faCircleCheck,
    faClock,
    faGift,
    faHeadset,
    faHeart,
    faLeaf,
    faLock,
    faShieldCheck,
    faStar,
    faTag,
    faThumbsUp,
    faTruck,
} from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const cast = (icon: unknown) => icon as IconDefinition;

const iconMap: Record<string, IconDefinition> = {
    facebook: cast(faFacebook),
    instagram: cast(faInstagram),
    'linkedin-in': cast(faLinkedinIn),
    pinterest: cast(faPinterest),
    twitter: cast(faTwitter),
    youtube: cast(faYoutube),
    tiktok: cast(faTiktok),
    snapchat: cast(faSnapchat),
    truck: cast(faTruck),
    'shield-check': cast(faShieldCheck),
    'circle-check': cast(faCircleCheck),
    star: cast(faStar),
    tag: cast(faTag),
    'box-open': cast(faBoxOpen),
    clock: cast(faClock),
    headset: cast(faHeadset),
    gift: cast(faGift),
    award: cast(faAward),
    heart: cast(faHeart),
    'thumbs-up': cast(faThumbsUp),
    lock: cast(faLock),
    leaf: cast(faLeaf),
};

export function getIcon(iconName?: string | null): IconDefinition | null {
    if (!iconName) return null;
    return iconMap[iconName.toLowerCase()] ?? null;
}
